import { render, staticRenderFns } from "./Panels.vue?vue&type=template&id=7f387a1a"
import script from "./Panels.vue?vue&type=script&lang=js"
export * from "./Panels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports